export const EXCMAGREEMENTTYPE_CREATE_RESET = 'EXCMAGREEMENTTYPE_CREATE_RESET'
export const EXCMAGREEMENTTYPE_CREATE_SET_CREATED = 'EXCMAGREEMENTTYPE_CREATE_SET_CREATED'
export const EXCMAGREEMENTTYPE_CREATE_SET_ERROR = 'EXCMAGREEMENTTYPE_CREATE_SET_ERROR'
export const EXCMAGREEMENTTYPE_CREATE_SET_VIOLATIONS = 'EXCMAGREEMENTTYPE_CREATE_SET_VIOLATIONS'
export const EXCMAGREEMENTTYPE_CREATE_TOGGLE_LOADING = 'EXCMAGREEMENTTYPE_CREATE_TOGGLE_LOADING'
